module.exports = __webpack_public_path__ + "img/img13.91a2f05d.svg";